import RecruitApiClient from '../../../../../components/RecruitApiClient';
import React, { useEffect, useRef, useCallback } from 'react';
import { Box } from '@mui/material';
import { classes } from './styles';

type SeekAdPerformanceProps = {
  adId: number
  positionProfileId: string;
};

const SeekAdPerformancePanel = ({
  adId,
  positionProfileId,
}: SeekAdPerformanceProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const getAuthToken = useCallback(async () => {
    const { res } = await RecruitApiClient.get<{ token: string }>(`/api/v4/seek/ad_performance_auth_token`, { job_ad_id: adId })

    return res.token
  }, [adId]);

  useEffect(() => {
    if (window.SeekApi && containerRef.current) {
      window.SeekApi.render(containerRef.current, 'adPerformance', {
        getAuthToken,
        positionProfileId,
      });
    }
  }, [getAuthToken, positionProfileId]);

  return (
    <Box sx={classes.seekAdPerformancePanelContainer}>
      <div ref={containerRef} />
    </Box>
  );
};

export default SeekAdPerformancePanel;
